import { AnalyticsAppEventData } from "client/Api/Analytics/analytics";
import { AppType } from "client/Api/Apps/common";
import { useAnalyticsStore } from "client/Features/Analytics/analyticsStore";
import { useRecentlyOpenedResults } from "client/Features/Search/RecentSearch/Persistence/useRecentlyOpenedResults";
import { useCallback } from "react";
import { RecentlyOpenedItemConfigurationProps, useResolveRecentlyOpenedItemForPersistence } from "./useResolveRecentlyOpenedItemForPersistence";
import { GlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/models";
import { getHubUrlForCommunity } from "client/Features/Hub/Communities/CommunitiesPage";
import { HubDataSource } from "client/Api/Hub/hub";
import { navigateTo } from "client_legacy/ndaw/navigator";

export type CommunityNavigationHandlerProps = {
	id: number;
}
	& RecentlyOpenedItemConfigurationProps;

export function useCommunityNavigationHandler(props: CommunityNavigationHandlerProps): (() => void) {
	const {
		id
	} = props;

	const addAnalyticsAppEvent: (data: AnalyticsAppEventData) => void = useAnalyticsStore(x => x.addAppEvent);
	const { registerFromRecentlyOpened: registerRecentlyOpenedItem } = useRecentlyOpenedResults();
	const recentlyOpenedItem: GlobalSearchItemPersistedModel = useResolveRecentlyOpenedItemForPersistence(props);

	return useCallback(
		(): void => {
			addAnalyticsAppEvent({ appType: AppType.Hub });
			registerRecentlyOpenedItem(recentlyOpenedItem);
			navigateToCommunity(id);
		},
		[
			addAnalyticsAppEvent,
			id,
			recentlyOpenedItem,
			registerRecentlyOpenedItem
		]
	);
}

export function navigateToCommunity(id: number): void {
	const url: string = getHubUrlForCommunity({
		source: HubDataSource.Community,
		communityId: id
	});

	navigateTo(url);
}
